import React from "react";
import img from "../../images/30Days.jfif";
import extension from "../../images/extension.png";
import data from "../../images/data.png";
import AR from "../../images/AR.png"
import py from "../../images/py.png"
import journal from "../../images/journal.png"
import covid from "../../images/covid.png";
import linkedin from "../../images/LinkedIn.png";
import behance from "../../images/Behance.png";
import "./projectStyle.css";

const Project = () => {
  return (
    <div className="wrap">
      <div className="header">
        Projects.
        <p>
          I keep busy by working on different stuff, here are some which are
          worth mentioning.
        </p>
      </div>
      {/* Column-1 */}
      <div className="gallery">
        <div className="column-item">
          <a href="https://github.com/Aishanipach/Miniplay" className="project" target="_blank">
            <img className="frame" alt="img1" src={extension} />
            <div className="caption">
              Wanted to code and follow<br></br> a tutorial side by side.
              <br></br>So, I made this.
              <div className="tags">JS, RESTFUL APIs, CHROME EXTENSION</div>
            </div>
          </a>

         <a href="https://github.com/Aishanipach/Data-Visualizer" className="project" target="_blank">
            <img className="frame" alt="img2" src={data} />
            <div className="caption">
              Presenting DATA,<br></br> but beautifully.
              <div className="tags">REACT.JS, RECHARTS.JS</div>
            </div>
          </a>

          <a target="_blank" href="https://medium.com/acm-juit/how-to-get-started-arfoundation-in-unity-f0a050b3585f?source=user_profile---------0-------------------------------" className="project">
            <img className="frame" alt="img3" src={AR} />
            <div className="caption">
              AR application for placing <br></br> 3D bridge model on multi-
              <br></br> terrain.
              <div className="tags">UNITY ENGINE, ARCORE, C# SCRIPTING</div>
            </div>
          </a>
        </div>

        {/* Column-2 */}
        <div className="column-item">
          <a href="https://github.com/Aishanipach/5-minute-journal" className="project" target="_blank">
            <img className="frame" alt="img4" src={journal} />
            <div className="caption">
              Daily journal app for<br></br>productivity (and also, it’s
              <br></br>customizable).
              <div className="tags">REACT.JS, POMODORO API</div>
            </div>
          </a>

          <a href="https://github.com/Aishanipach/Beginners-Python-Projects" className="project" target="_blank"> 
            <img className="frame" alt="img5" src={py} />
            <div className="caption">
              Basic Python Projects for <br></br>starters
              <div className="tags">PYTHON, DATA SCRAPING, GMAIL API</div>
            </div>
          </a>

          <a href="https://github.com/Aishanipach/Covid-dashboard/tree/newtest" className="project" target="_blank">
            <img className="frame" alt="img6" src={covid} />
            <div className="caption">
              Live COVID-19 Tracker<br></br> for location-based<br></br>cases
              <div className="tags">REACT, FIREBASE, MATERIAL UI</div>
            </div>
          </a>
        </div>
      </div>
      <a href="https://github.com/Aishanipach" className="github" target="_blank">
        More on Github...
      </a>
      <div className="dividerp">
        <a href="https://www.behance.net/gallery/118649965/30daysofdesign" target="_blank">
        <img src={img} className="imagep" alt="30Days" /></a>
        <div className="quote">
          {" "}
          "If you forget everything around you while<br></br> doing something,
          that's your passion."
        </div>
        <div className="textt">For me that's designing, what's your?</div>
      </div>

      <div className="cases">
        <div className="case-head">Case Studies</div>
        <div className="case-1">
          
          <img className="imageb" src={behance} />
          <div className="line1"></div>
          <div className="descript">
            <div className="head">MICROSOFT TEAMS</div>
            <div className="case-descript">Redesigning Teams app for Windows for better group deck organisation and enhancing<br></br>visual hierarchy.</div>
          </div>
        </div>

        <div className="case-1">
          
          <img className="imageb" src={linkedin} />
          <div className="line1"></div>
          <div className="descript">
            <div className="head">KELLOGG'S</div>
            <div className="case-descript">Break it but then Make it when entering a new, culturally diverse market,<br></br>all thanks to corrected marketing.</div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Project;
